export const getClassNameForProfitAndLoss = (value: number): string => {
	const color = value < 0 ? "negative" : value > 0 ? "positive" : "neutral";
	return `backtest-profit-and-loss-${color}`;
};
